//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'miniUserManage',
  components: {
    cmBlank,
    cmLoadmore
  },
  data () {
    return {
      keyword: '',
      list: [],
      tagOptions: [],
      currentUser: {},
      checkedTagIds: [],
      selectedTagId: 0,
      tagPop: false,
      blankShow: false,
      loadStatus: false,
      loadmoreText: '正在加载。。。',
      busy: false,
      hasNext: 0,
      pageFlag: 2,
      lastId: 0,
      saving: false
    }
  },
  created(){
    this.getTagOptions();
    this.loadmore();
  },
  methods: {
    search(){
      this.list = [];
      this.lastId = 0;
      this.hasNext = 0;
      this.blankShow = false;
      this.busy = false;
      this.loadmore();
    },
    resetSearch(){
      this.keyword = '';
      this.search();
    },
    getList(){
      return this.$api.miniUserList({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,tag_id:this.selectedTagId}).then((res)=>{
        if(res){
          if(!this.lastId){
            this.blankShow = res.data.length == 0;
          }
          this.hasNext = res.hasNext;
          this.lastId = res.lastId;
          res.data.forEach((item)=>{
            this.list.push(item);
          });
        }
      })
    },
    loadmore(){
      if(this.lastId > 0 && !this.hasNext){
        this.busy = true;
        this.loadStatus = true;
        this.loadmoreText = '没有更多了。。。';
        return;
      }
      this.busy = true;
      this.loadStatus = true;
      this.loadmoreText = '正在加载。。。';
      this.getList().finally(()=>{
        if(this.blankShow){
          this.busy = true;
          this.loadStatus = false;
        }else if(this.hasNext > 0){
          this.busy = false;
          this.loadStatus = false;
        }else{
          this.busy = true;
          this.loadStatus = true;
          this.loadmoreText = '没有更多了。。。';
        }
      })
    },
    getTagOptions(){
      this.$api.miniUserTagOptions({}).then((res)=>{
        if(res){
          this.tagOptions = res.data || [];
        }
      })
    },
    selectTagFilter(id){
      id = Number(id);
      if(this.selectedTagId === id){
        return false;
      }
      this.selectedTagId = id;
      this.search();
    },
    openTagPop(user){
      this.currentUser = user;
      this.checkedTagIds = (user.tag_list || []).map(item => Number(item.id));
      this.tagPop = true;
    },
    closeTagPop(){
      this.tagPop = false;
    },
    isChecked(id){
      return this.checkedTagIds.indexOf(Number(id)) > -1;
    },
    toggleTag(id){
      id = Number(id);
      let index = this.checkedTagIds.indexOf(id);
      if(index > -1){
        this.checkedTagIds.splice(index, 1);
      }else{
        this.checkedTagIds.push(id);
      }
    },
    viewUserOrders(user){
      if(!user.phone){
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({name:'order',params:{type:1,i:0},query:{phone:user.phone}});
    },
    viewWashRecords(user){
      if(!user.phone){
        this.$func.showToast('用户未绑定手机号');
        return false;
      }
      this.$router.push({name:'recordPhoneList',query:{phone:user.phone}});
    },
    copyPhone(phone, event){
      if(!phone){
        return false;
      }
      this.$func.copy(phone, event);
    },
    removeUserTag(user, tag){
      if(this.saving){
        return false;
      }
      let tagId = Number(tag.id);
      let nextTags = (user.tag_list || []).filter(item => Number(item.id) !== tagId);
      this.saving = true;
      this.$api.saveMiniUserTags({uid:user.uid,tag_ids:nextTags.map(item => item.id).join(',')}).then((res)=>{
        if(res){
          this.$set(user, 'tag_list', nextTags);
          this.$set(user, 'tag_text', nextTags.map(item => item.name).join('，'));
          if(this.currentUser.uid === user.uid){
            this.checkedTagIds = nextTags.map(item => Number(item.id));
          }
          this.$func.showToast('删除成功');
        }
      }).finally(()=>{
        this.saving = false;
      })
    },
    tagStyle(tag){
      let checked = this.isChecked(tag.id);
      return {
        color: checked ? '#ffffff' : '#333333',
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    filterTagStyle(tag){
      let checked = this.selectedTagId === Number(tag.id);
      return {
        color: checked ? '#ffffff' : tag.color,
        borderColor: tag.color,
        backgroundColor: checked ? tag.color : this.tagBgColor(tag.color)
      };
    },
    tagBgColor(color){
      if(!color || color.indexOf('#') !== 0){
        return '#f7f8fa';
      }
      let hex = color.replace('#', '');
      if(hex.length === 3){
        hex = hex.split('').map(item => item + item).join('');
      }
      if(hex.length !== 6){
        return '#f7f8fa';
      }
      let r = parseInt(hex.slice(0, 2), 16);
      let g = parseInt(hex.slice(2, 4), 16);
      let b = parseInt(hex.slice(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',0.08)';
    },
    hasTagEffect(tag){
      return this.tagEffectText(tag) !== '';
    },
    tagEffectText(tag){
      if(!tag){
        return '';
      }
      if(tag.effect_text){
        return tag.effect_text;
      }
      let code = tag.effect_code || '';
      if(!code || code === 'none'){
        return '';
      }
      let map = {
        store_no_call: '扫码免打电话',
        store_deny_open: '扫码禁止开门'
      };
      return map[code] || code;
    },
    showTagEffectTip(tag){
      let text = this.tagEffectText(tag);
      if(text){
        this.$func.showToast(text);
      }
    },
    submitTags(){
      if(this.saving){
        return false;
      }
      this.saving = true;
      this.$api.saveMiniUserTags({uid:this.currentUser.uid,tag_ids:this.checkedTagIds.join(',')}).then((res)=>{
        if(res){
          let selected = this.tagOptions.filter(item => this.checkedTagIds.indexOf(Number(item.id)) > -1);
          this.$set(this.currentUser, 'tag_list', selected);
          this.$set(this.currentUser, 'tag_text', selected.map(item => item.name).join('，'));
          this.closeTagPop();
        }
      }).finally(()=>{
        this.saving = false;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/miniUserManage.vue